import { TFunction } from 'i18next';
import { array, object, ObjectSchema, string } from 'yup';

import { NewEmailFormModel } from '@/components/emailWindow/model/NewEmailForm.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';

export const emailValidation = (t: TFunction) =>
  object({
    email: string().email(t('email')).required(t('general.required')),
    label: string().required(t('general.required')),
    value: string().required(t('general.required')),
  });

export const useNewEmailValidation = (): ObjectSchema<NewEmailFormModel> => {
  const { t } = useTranslationWithPrefix('validation');

  return object().shape({
    bcc: array()
      .of(emailValidation(t))
      .required(t('general.required'))
      .meta({ doNotValidate: true }),
    body: string().required(t('general.required')),
    cc: array()
      .of(emailValidation(t))
      .required(t('general.required'))
      .meta({ doNotValidate: true }),
    emailId: string().required(),
    from: string().required(t('general.required')),
    subject: string().required(t('general.required')),
    threadId: string().required(),
    to: array()
      .of(emailValidation(t))
      .required(t('general.required'))
      .min(1, t('general.required')),
  });
};
